<template>

        <div class="container-fluid front_header">
            <div class=" ">
              <div class="row">
                <div class="col-12">
                  <img class="img-fluid for_logo" src="../../../assets/images/logo/hcelogo.png"
                                    alt="looginpage">
                </div>
              </div>
            </div>
          </div>
          <div class="page-body">
              
                <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class="user-profile social-app-profile">
                    <div class="card">
                                <div class="card-body socialprofile filter-cards-view">
                        <div class="login-main"  >

                            <h4>Fill Gatepass Details </h4>
                            
                            <div class="form-group">
                                <label class="col-form-label">Purpose</label>
                                <!--<input class="form-control" type="text" v-model="gatepass.purpose"-->
                                <!--    placeholder="Type Here..." required="">-->
                                 <select v-model="gatepass.purpose" class="form-select">
                                      <option disabled selected>Select Purpose</option>
                                      <option v-for="purpose in purpose_list" :key="purpose" :value="purpose">
                                        {{ purpose }}
                                      </option>
                                    </select>
                            </div>
                            
                            <div class="form-group">
                                <label class="col-form-label">Respective Authority</label>
                               <!--<Autocomplete -->
                               <!--       :items="emp_list" -->
                               <!--       labelField="empname" -->
                               <!--       valueField="id"-->
                               <!--       placeholder="Search Staff To Meet"-->
                               <!--       @select="handleSelectStaff" />-->
                               <select id="select2" class="form-control" v-model="gatepass.whom_userid">
                                     <option value="0" disabled="" selected="">SELECT STAFF</option>
                                      <option v-for="emp in emp_list" :key="emp.id" :value="emp.id">
                                        {{ emp.empname }}
                                      </option>
                                    </select>
                                      
                                <!--<select class="form-select" required="" v-model="gatepass.whom_userid">-->
                                <!--        <option selected="" disabled="" value="">Choose...</option>-->
                                <!--        <option v-for="item   in emp_list" :key="item.id" :value="item.id">{{item.empname }}</option>-->
                                <!--    </select>-->
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Schedule Date</label>
                                <input class="form-control" type="date" v-model="gatepass.schedule_date" :min="gatepass.mindate" required >
                            </div>

                            <div class="text-end mt-3">
                                <button class="btn btn-primary btn-block w-100" @click="saveData">Submit</button>
                            </div>
                 


                        </div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  <div class="fixed-bottom bg-light border-top shadow-sm">
    <div class="d-flex justify-content-around text-center py-2">
      <router-link to="/visitorpage" class="text-decoration-none text-dark">
        <div><i class="fa fa-home fa-lg"></i></div>
        <small>Home</small>
      </router-link>
      <router-link to="/ActivePage" class="text-decoration-none text-dark">
        <div><i class="fa fa-bolt fa-lg"></i></div>
        <small>Active</small>
      </router-link>
      <router-link to="/PastPage" class="text-decoration-none text-dark">
        <div><i class="fa fa-history fa-lg"></i></div>
        <small>Past</small>
      </router-link>
      <router-link to="/ProfilePage" class="text-decoration-none text-dark">
        <div><i class="fa fa-user fa-lg"></i></div>
        <small>Profile</small>
      </router-link>
      <a @click="creategatepass" class="text-decoration-none text-dark">
        <div><i class="fa fa-plus-circle fa-lg"></i></div>
        <small>Create</small>
      </a>
    </div>
  </div>

    </div>


</template>
<style scoped>
 
.page-body {
    margin-left: 0 !important;
    margin-top: 0px;
}

.user-profile .hovercard .cardheader {
    height: 100px;
    background: linear-gradient(45deg, #0437c8, #007611);
}

@media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
        position: sticky;
    }
}
</style>

<script>
// import axios from 'axios';
import axios from "@/plugins/axios";

export default {
    name: 'VisitorCreateGatepass',
    components: {

    },
    mounted() {

        if (this.$route.query.id) {
           
            this.getEmps(this.$route.query.id);

        }
        else{
          
            this.getEmps(0);
        }


    },
    watch: {
         emp_list() {
            this.$nextTick(() => {
              if ($('#select2').hasClass('select2-hidden-accessible')) {
                $('#select2').select2('destroy');
              }
              this.initSelect2();
            });
          }
        },
    data() {
        return {
            emp_list: [],
            last_record:[],

            gatepass:{
                purpose: '',
                whom_userid:0,
                mindate: new Date().toISOString().split('T')[0]  ,
                schedule_date:this.getCurrentDate(),
            },
            purpose_list:[]//30.05.2025
         
        }
    },
    methods: {  
           handleSelectStaff(selectedStaff) {
              this.gatepass.whom_userid= selectedStaff.id;
            },
            
        getCurrentDate() {
    //   const today = new Date();
    //   const yyyy = today.getFullYear();
    //   const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    //   const dd = String(today.getDate()).padStart(2, '0');

    //   return `${yyyy}-${mm}-${dd}`;
    
    return new Date().toISOString().split('T')[0] ;
    },
        getEmps(id=0) {
            var self = this;
            axios.post('getEmployeesForPassCreation',{id:id}).then(function (response) {
               
                self.emp_list = response.data.employees; 
                self.last_record = response.data.last_record; 
                self.purpose_list = response.data.purpose_list; 
                if(response.data.user && (response.data.user.aadharcard=='' || response.data.user.aadharcard==null))
                {
                     self.$swal("Please Update Adhar Card");
                    self.$router.push({ name: "ProfilePage" });
                }
               
               
                if(response.data.gatepass){
                    self.gatepass = response.data.gatepass;
                }
     

                // window.scrollTo(0, 0);
            });
        },
    saveData() {
        var self = this;
        if (self.gatepass.purpose == '')
        self.$swal("Please Enter Purpose"); 
        else if (self.gatepass.whom_userid == '')
        self.$swal("Please Select Person To Meet");
        else
        {
            axios.post('createVisitorGatePass',self.gatepass).then(function (response) {
                if(response.data.gatepass_success==1){ 
                    self.$swal({
                            title: "Successfull",
                            text: ""+response.data.gatepass_statusmsg,
                            type: "warning"
                        }).then((result) => { // <--
                             
                                self.$router.push({ name: "visitorpage" });  
                        });
                        //self.$router.push({ name: "visitorpage" });  
                }else
                self.$swal(response.data.gatepass_statusmsg).then((result) => { // <--
                             
                                self.$router.push({ name: "visitorpage" });  
                        });;

              //  window.scrollTo(0, 0);
            });
        }
    },


  //15.05.2025
        initSelect2() {
            const self = this;
            $('#select2')
              .off('select2:select') // Avoid duplicate handlers
              .on('select2:select', function (e) {
                const selectedId = e.params.data.id;
                self.gatepass.whom_userid= selectedId;
                
                // console.log("Selected employee ID:", selectedId);
              });
        
            $('#select2').select2();
          }, 



}
}
</script>
